module.exports = __webpack_public_path__ + "images/cart-57efead8934fb127f24638ed17c475ba.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cart.svg
// module id = 50
// module chunks = 0 1